import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Tenant } from 'src/app/models/tenant.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-tenant]',
  template: `
    <td class="align-middle">
      <a routerLink="edit/{{tenant?.id}}">{{tenant?.name}} {{tenant?.last_name}}</a>
    </td>
    <td class="align-middle">{{tenant?.email}}</td>
    <td class="align-middle text-center">
      <span *ngFor="let unit of tenant?.units">{{unit.name}} {{unit.number}}</span>
    </td>
    <td class="align-middle text-center">
      <div class="badge badge-pill bg-primary" *ngIf="tenant?.thsm_id">THSM {{tenant?.thsm_id}}</div> 
      <div class="badge badge-pill bg-primary" *ngIf="tenant?.trade_id">TRADE {{tenant?.trade_id}}</div>
    </td>
    <td class="align-middle text-center">
      <button type="button" class="btn btn-outline-danger ms-2"
        (click)="removeUser(tenant!)"
      >
        <!-- *ngIf="permissions?.modules.config.tenants.write" -->
        <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrTenantComponent {
  @Input() tenant: Tenant | null = null;
  @Input() profile: any;
  @Input() permissions: any;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  removeUser(tenant: Tenant) {
    this.store.destroyUser(tenant.id).subscribe({
      next: (data: any) => {
        this.toastr.success('Usuario eliminado correctamente.', 'Éxito');
        // this.loadUsers(this.payload);
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al eliminar el usuario.', 'Error');        
      },
    });
  }
}
